import React, { useEffect } from "react";
import { FaastSmartTable } from './FaastSmartTable'
import { useTable } from './useTable'

export const TableRender = ({ 
    datos = {
      columns:[],
      rows:[]
    },
    title = '',
    allowGlobalFilter = false,
    allowNativeExcelDownload = false,
    showOpciones = false,
    allowResizeCols = false,
    allowReorderCols = false,
    allowColumnPinning = false,
    allowColumnGrouping = false,
    allowColumnSortingSingle = true,
    showSelectItemperPage = true,
    itemsPerPageDefault = 10,
    handleChangeCheck = ()=>{},
    selectableRowSelected = {},
    fontSizeTable = '',
    exportedFileName = '',
    showPagination = true
}) => {

  const { ...pr } = useTable({
    defaultColumns: datos.columns,
    data: datos.rows
  })

  useEffect(()=>{
    // console.log('pr.table', { pr: pr, table:pr.table})
    pr.table.setPageSize(itemsPerPageDefault)
    pr.table.setRowSelection(selectableRowSelected)
  },[])

  useEffect(()=>{
    selecRows();
  }, [pr.rowSelection])

  const selecRows = ()=>{
    const rows = pr.table.getSelectedRowModel().rows.map((item)=> item.original )
    handleChangeCheck(rows)
  }

  return (
    <>

     <FaastSmartTable 
        table={ pr.table }
        title={title}
        allowGlobalFilter={allowGlobalFilter}
        allowColumnSubcomponents
        allowResizeCols={allowResizeCols}
        allowReorderCols={allowReorderCols}
        allowColumnFilter
        allowColumnPinning={allowColumnPinning}
        allowColumnSorting
        hideTableOptions
        allowColumnSortingSingle={allowColumnSortingSingle}
        allowColumnGrouping={allowColumnGrouping}
        allowHandleVisibility
        allowNativeExcelDownload={allowNativeExcelDownload}
        showSelectItemperPage={showSelectItemperPage}
        grouping={pr.grouping}
        setGrouping={pr.setGrouping}
        globalFilter={pr.globalFilter}
        setGlobalFilter={pr.setGlobalFilter}
        fontSizeTable={fontSizeTable}
        customRender={(row)=><pre>{JSON.stringify(row,null,2)}</pre>}
        lengthHeaderColumn={datos.columns?.length}
        pinning={pr.columnPinning}
        exportedFileName={exportedFileName}
        showPagination={showPagination}
     />
    </>
  )
}